import React from 'react';
import { useTranslation } from 'react-i18next';
import Reveal from './ui/Reveal';

// Verbatim from the CV's TECHNICAL SKILLS table — same groups, same members,
// same order. No additions.
const categories = [
  { titleKey: 'skills.cat.mobile', skills: ['Flutter', 'Dart', 'BLoC', 'Provider'] },
  {
    titleKey: 'skills.cat.backendFull',
    skills: ['.NET / C#', 'Laravel', 'RESTful API design', 'Database Design (SQL/NoSQL)'],
  },
  {
    titleKey: 'skills.cat.frontend',
    skills: ['Flutter Web', 'HTML/CSS fundamentals for admin dashboards'],
  },
  { titleKey: 'skills.cat.cloud', skills: ['Firebase', 'Supabase'] },
  { titleKey: 'skills.cat.payments', skills: ['Stripe', 'PayPal', 'MyFatoora'] },
  {
    titleKey: 'skills.cat.practices',
    skills: ['Clean Code', 'Design Patterns', 'Git', 'Performance Optimisation'],
  },
];

const aiTools = ['Claude', 'Claude Code', 'Cursor Agents'];

/**
 * A definition list, not a logo grid and not percentage bars. The content is
 * genuinely "category: these things", so the structure says exactly that.
 */
const Skills: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="skills" className="section">
      <div className="container-page">
        <Reveal>
          <p className="eyebrow">{t('skills.eyebrow')}</p>
          <h2 className="section-title mt-4 max-w-2xl">{t('skills.title')}</h2>
          <p className="mt-5 max-w-prose text-graphite">{t('skills.subtitle')}</p>
        </Reveal>

        <Reveal className="mt-10" delay={80}>
          <dl>
            {categories.map((cat) => (
              <div
                key={cat.titleKey}
                className="row-ruled sm:grid-cols-[minmax(0,15rem)_1fr] sm:items-baseline"
              >
                <dt className="ui text-[12px] font-semibold uppercase tracking-[0.16em] text-graphite">
                  {t(cat.titleKey)}
                </dt>
                <dd>
                  <ul className="flex flex-wrap gap-x-6 gap-y-2">
                    {cat.skills.map((skill) => (
                      <li key={skill} className="ui text-[17px] text-ink">
                        {skill}
                      </li>
                    ))}
                  </ul>
                </dd>
              </div>
            ))}

            <div className="row-ruled border-b border-hairline sm:grid-cols-[minmax(0,15rem)_1fr] sm:items-baseline">
              <dt className="ui text-[12px] font-semibold uppercase tracking-[0.16em] text-graphite">
                {t('skills.aiTitle')}
              </dt>
              <dd>
                <ul className="flex flex-wrap gap-x-6 gap-y-2">
                  {aiTools.map((tool) => (
                    <li key={tool} className="ui text-[17px] text-ink">
                      {tool}
                    </li>
                  ))}
                </ul>
              </dd>
            </div>
          </dl>
        </Reveal>
      </div>
    </section>
  );
};

export default Skills;
